import { Stack } from '@koob/margaret';
import { KoobEmptyState } from '@koob/ui';
import Spinner from 'components/Spinner';
import { useTranslation } from 'react-i18next';
import { ExperiencesGrid } from 'ui';
import ExperienceCard from './ExperienceCard';
import { useMemo } from 'react';
import { archiveExperience } from 'api/node/experiences';
import { useError } from 'react-use';
import { useSnack } from 'hooks';
import { KoobMutliSelectGrid } from 'components/Koob/KoobMutliSelectGrid';

const ExperiencesList = ({
  experiences,
  isEmpty,
  isLoading,
  perPage,
  setTotalPages,
  reload,
}) => {
  const { t } = useTranslation('experiences');
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  useMemo(() => {
    const pageCount = Math.ceil((experiences?.length ?? 0) / perPage);
    setTotalPages(pageCount);
    return experiences;
  }, [experiences]);

  const handleDelete = async (selectedIds) => {
    try {
      await archiveExperience({ experienceIds: selectedIds });
      notify(t('archiveSuccess'));
      reload();
    } catch (err) {
      if (err?.response?.data?.message) {
        notify(err?.response?.data?.message, { type: 'error' });
      } else {
        sendErrorSnack(err);
      }
    }
  };

  return (
    <Stack className="relative" size="full" direction="column" gutterSize={0.5}>
      {isLoading && <Spinner />}
      {isEmpty && !isLoading ? (
        <KoobEmptyState title={t('emptyStateMessage')} />
      ) : (
        <Stack direction="column" size="full" alignX="center" gutterSize={1}>
          <KoobMutliSelectGrid
            items={experiences}
            onDelete={handleDelete}
            GridComponent={ExperiencesGrid}
            renderCard={(experience, cardProps) => (
              <ExperienceCard
                key={experience.id}
                experience={experience}
                {...cardProps}
              />
            )}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default ExperiencesList;
